export enum DeliveryType {
    BranchDelivery,
    CourierDelivery
}